<template>
  <div>
    <van-action-sheet v-model="ksShow" cancel-text="取消" @close="close">
      <van-search shape="round" v-model="searchValue" placeholder="请输入搜索关键词" @input="inputChange" />

      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell v-for="item in dataList" :key="item.id" :title="item.name" @click="ksSelect(item.name)"/>
        <span v-if="dataList.length < 1">暂无数据</span>
        <br/>
        <div style="height: 10px"></div>
        <van-button @click="openInput" round plain hairline type="primary" size="small">手动输入科室</van-button>
      </van-list>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: "KeShi",
  data() {
    return {
      searchValue: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      ksShow: true,
      dataList: [],
      pageNum: 1,
      total: 10,
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    openInput() {
      // 手动输入科室
      this.$emit('change', {type: 'openInput2'})
    },
    inputChange(val) {
      this.dataList = []
      this.pageNum = 1
      this.get()
    },
    onLoad() {
      this.pageNum++
      this.get()
      if (this.pageNum >= this.total) {
        this.finished = true;
      }
    },
    get() {
      let params = {
        pageSize: 200,
        pageNum: this.pageNum,
        params: {
          name: this.searchValue || null
        }
      }
      this.$http.post(this.$api.officeList, params).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          this.dataList = this.dataList.concat(data.content)
          this.loading = false;
          this.total = data.totalPages
        } else {
          this.$toast(message)
        }
      })
    },
    close() {
      this.$emit('change')
    },
    ksSelect(e) {
      this.$emit('change', {value: e})
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-action-sheet__content {
    min-height: 400px;
  }
}
.content-box {
  position: relative;
  .search-box {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
